import React, { forwardRef, memo } from "react";

import { ODSTextProps } from "./ODSText.types";

const ODSText = forwardRef<HTMLElement, ODSTextProps>(
  ({ children, as: HTMLTag = "span", ...rest }, ref) => {
    return (
      <HTMLTag ref={ref} {...rest}>
        {children}
      </HTMLTag>
    );
  }
);

ODSText.displayName = "ODSText";
export default memo(ODSText);
